import React from 'react';

import AppModal from 'components/modal/appModal';
import { DeleteAssetModalProps } from './DeleteAssetModal';

type DeleteAssetModalContentProps = DeleteAssetModalProps & {
  removeAsset: () => void;
};

export const DeleteAssetModalContent = ({ id, data: { asset }, removeAsset }: DeleteAssetModalContentProps) => {
  return (
    <AppModal
      id={id}
      title="Delete VG asset"
      hideOpenButton
      submitButtonLabel="Yes"
      submitAction={removeAsset}
      closeButtonLabel="No"
      className="delete-modal"
    >
      <p>
        Are you sure you want to delete <strong>{asset}</strong> for this participant?
      </p>
    </AppModal>
  );
};
